import { Button, Grid } from '@material-ui/core';
import Chip from '@mui/material/Chip';
import Authorize from 'components/Authorize';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import EmptyPlaceholder from 'components/EmptyPlaceholder/EmptyPlaceholder';
import LoadingSpinner from 'components/LoadingSpinner';
import { useGetAllActivityItemsQuery } from "features/activity/activitySlice";
import { useGetVendorsQuery } from 'features/vendor/vendorSlice';
import { IconEdit } from "icons";
import { useHistory } from "react-router-dom";
import { arrayToObject } from 'utils/object-util';
import { useGetActivityPricingByLotIdQuery } from '../../../../pricing/pricingSlice';
import { lotDialogStyle } from "../LotDialogStyle";

const LotVendors = ({ lotId }) => {
    const classes = lotDialogStyle();

    const history = useHistory();

    let { data: activityItems, error: activityItemsError, isFetching: isLoadingActivityItems } = useGetAllActivityItemsQuery();
    let { data: vendors, error: vendorsError, isLoading: isLoadingVendors } = useGetVendorsQuery();
    let { data: prices, error: pricesError, isLoading: isLoadingPrices } = useGetActivityPricingByLotIdQuery(lotId, { skip: !lotId });

    activityItems = activityItems || [];
    vendors = vendors || [];
    prices = prices || [];

    const activitiesLookup = arrayToObject(activityItems, 'id');

    // Grouping prices by vendorId and filtering out duplicate activities
    const groupedData = vendors
        ?.filter(vendor => prices?.some(price => price?.vendorId === vendor?.id))
        ?.map(vendor => {
            const vendorPrices = prices?.filter(price => price?.vendorId === vendor?.id);
            const distinctActivityIds = new Set();
            const uniquePrices = vendorPrices?.filter(p => !p.notSupported)?.filter(price => {
                if (!distinctActivityIds?.has(price?.activityItemId)) {
                    distinctActivityIds?.add(price?.activityItemId);
                    return true;
                }
                return false;
            });
            const activities = uniquePrices?.map(price => activitiesLookup[price?.activityItemId]);
            return {
                vendor,
                activities
            };
        });

    const isLoading = isLoadingActivityItems || isLoadingVendors || isLoadingPrices;

    const goToPricingDb = () => {
        history.push(`/pricing?selectedTab=1&lotId=${lotId}`);
    }

    return (
        <>
            <LoadingSpinner loading={isLoading} />
            <Grid container>

                <Grid item xs={12}>
                    <Grid item xs={12} className={classes.emptyWrapper}>
                        {!groupedData?.length && <EmptyPlaceholder text='No Vendors Found' />}
                    </Grid>
                    {groupedData?.map((group) => (
                        <div key={group.vendor?.id}>
                            <Grid container alignItems='center' justifyContent='flex-start' direction='column' className={classes.vendorWrapper}>
                                <Grid container >
                                    <Grid item >
                                        <label className={classes.vendorName}>{group.vendor?.name}</label>
                                    </Grid>
                                </Grid>
                                <Grid container direction='row'>
                                    {group.activities?.map(activity => (
                                        <Grid item key={activity?.id} className={classes.vendorChip}>
                                            <Chip label={activity?.name} />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </div>
                    ))}
                </Grid>

                <Authorize profile={permissionProfiles.PRICING.MANAGE_PPRICING}>
                    <Grid item xs={12} >
                        <Grid container>
                            <Button
                                variant="outlined"
                                onClick={() => goToPricingDb()}
                                startIcon={<IconEdit />}
                            >
                                Edit in Price DB
                            </Button>
                        </Grid>
                    </Grid>
                </Authorize>

            </Grid>
        </>
    );
}

export default LotVendors;